export const BRAND_TYPES_CONSTS = {
    GET_BRAND_TYPES: "GET_BRAND_TYPES",
    CREATE_BRAND_TYPES: "CREATE_BRAND_TYPES",
    UPDATE_BRAND_TYPES: "UPDATE_BRAND_TYPES",
    DELETE_BRAND_TYPES_BY_ID: "DELETE_BRAND_TYPES_BY_ID",
};
